export default "__VITE_ASSET__ClSEX0yu__"